import { render, staticRenderFns } from "./PrincipalAboutus.vue?vue&type=template&id=7fe68428&scoped=true&"
import script from "./PrincipalAboutus.vue?vue&type=script&lang=js&"
export * from "./PrincipalAboutus.vue?vue&type=script&lang=js&"
import style0 from "./PrincipalAboutus.vue?vue&type=style&index=0&id=7fe68428&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe68428",
  null
  
)

export default component.exports